import script from "./PhishingDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./PhishingDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./PhishingDetailsView.vue?vue&type=style&index=0&id=4bfd8b4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bfd8b4a"]])

export default __exports__